import React from "react";
import { connect } from "react-redux";
import "./Header.scss";
import { setScreen } from "../../../redux/actions";
import getNameFromUrl from "../../../scripts/lib/getNameFromUrl";
import LanguageSelector from "../../LanguageSelector/LanguageSelector";

const Header = (props) => {
  let publisherName =
    props.configuration?.publisherName ||
    getNameFromUrl(window.location?.ancestorOrigins?.[0]);
  const { configuration } = props;
  let { currentLanguage } = props;

  if (
    currentLanguage &&
    configuration?.domesticLanguages?.[currentLanguage.code + "-dom"]
  ) {
    currentLanguage =
      configuration.domesticLanguages[currentLanguage.code + "-dom"];
    // debugger;
  }

  const navigateBack = () => {
    if (props.currentScreen >= 1) props.setScreen(props.currentScreen - 1);
    if (props.currentScreen === 4) {
      props.setScreen(1);
    }
  };

  return (
    <div id="header">
      <div id="top">
        <div
          id="backButton"
          className={`${props.currentScreen === 1 ? "hide" : ""}`}
          style={{ background: `/images/back_arrow.svg` }}
          onClick={navigateBack}
        />
        {props.configuration?.logoUrl ? (
          <div id="publisherLogo">
            <img src={props.configuration.logoUrl} alt="logo" />
          </div>
        ) : null}
        <LanguageSelector />
      </div>
      <h1 className={`${props.currentScreen !== 1 ? "hide" : ""}`}>
        {currentLanguage.text.title} {publisherName}
      </h1>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};

export default connect(mapStateToProps, { setScreen })(Header);
